<template>
    <dealer-zones v-slot="{ dealerZones }" :params="params">
        <div class="dealer-zones">
            <div class="leading" v-if="isAdministrator">
                <button class="btn btn-primary" id="show-modal" @click="editDealerZone()">Add Dealer Zone</button>
            </div>
            <div class="table-responsive">
                <table class="table table-striped">
                    <thead class="manager-list-heading">
                        <tr>
                            <th>Zone Name</th>
                            <th>Price</th>
                            <th>Surcharge</th>
                            <th>Fee</th>
                            <th>Dealer</th>
                            <th>Active</th>
                            <th class="actions">Actions</th>
                        </tr>
                    </thead>
                    <tbody class="manager-list-row" v-for="zone in dealerZones" :key="zone.id">
                        <td class="name" v-text="zone.name"></td>
                        <td class="numeric" v-text="usd3(zone.price)"></td>
                        <td class="numeric" v-text="usd(zone.small_order_price_surcharge)"></td>
                        <td class="numeric" v-text="usd(zone.processing_fee)"></td>
                        <td v-text="zone.company.name"></td>
                        <td v-text="booleanFormat(zone.active)"></td>
                        <td class="actions">
                            <button class="btn btn-primary btn-sm" @click="editDealerZone(zone.id)">Edit</button>
                        </td>
                    </tbody>
                </table>
            </div>
            <dealer-zone-modal v-if="showModal" @close="showModal = false;" :id="modalDealerZone"></dealer-zone-modal>
        </div>
    </dealer-zones>
</template>
<script>
import DealerZoneModal from './DealerZoneModal';
import ModalWatcher from './ModalWatcher';
import numeral from 'numeral';
import { ContinuousCollectionComponent } from 'clockvine-vue';

export default {
    components: {
        DealerZoneModal,
        dealerZones: ContinuousCollectionComponent.for("dealerZones")
    },

    mixins: [
        ModalWatcher
    ],

    data: () => ({
        isAdministrator: false,
        showModal: false,
        modalDealerZone: null,
        params: {}
    }),

    mounted() {
        var user = JSON.parse(this.$root.$el.attributes['data-user'].value);
        this.isAdministrator = (user.role == 'Administrator');
    },

    methods: {
        booleanFormat(value) {
            return (value) ? 'Yes' : 'No';
        },

        percentFormat(amount) {
            return numeral(amount).format('0.00') + '%';
        },

        editDealerZone(id) {
            this.modalDealerZone = id;
            this.showModal = true;
        },
    },
}
</script>
